/**
 * @typedef PieceworkUnits
 * @property {'кв.метр'} SQUARE_METER
 * @property {'пдн'} PALLET
 * @property {'ящик'} BOX
 * @property {'час'} HOUR
 * @property {'чел./час'} MAN_HOUR
 * @property {'шт.'} PIECE
 * @property {'шт./час'} PIECE_HOUR
 * @property {'кг./час'} KG_HOUR
 */

/** @type {Readonly<PieceworkUnits>} */
const PIECEWORK_UNITS = {
  SQUARE_METER: 'кв.метр',
  PALLET: 'пдн',
  BOX: 'ящик',
  HOUR: 'час',
  MAN_HOUR: 'чел./час',
  PIECE: 'шт.',
  PIECE_HOUR: 'шт./час',
  KG_HOUR: 'кг./час',
};

module.exports = {
  PIECEWORK_UNITS,
};
